export const UMB_USER_ALLOW_ENABLE_CONDITION_ALIAS = 'Umb.Condition.User.AllowEnableAction';
